import styled from "@emotion/styled";
import { fontRobotoCondensed } from "@product/scmp-sdk";

import CloseIcon from "./close-icon.svg";

export const Container = styled.div`
  position: absolute;
  inset-block-start: 100%;
  inset-inline-start: 10px;
  z-index: 50;

  display: flex;

  max-inline-size: 296px;
  padding: 16px;

  column-gap: 12px;

  border-radius: 4px;

  background: rgba(0, 18, 70, 0.9);

  ${props => props.theme.breakpoints.up("tablet")} {
    inset-block-start: 50%;
    inset-inline-start: 32px;

    transform: translateY(-50%);
  }
`;

export const Message = styled.span`
  color: #ffffff;
  font-size: 16px;
  font-family: ${fontRobotoCondensed};
  line-height: 18.75px;
`;

export const Email = styled.span`
  color: #ffffff;
  text-decoration: underline;
`;

export const CloseButton = styled.div`
  cursor: pointer;
`;

export const StyledCloseIcon = styled(CloseIcon)``;
